import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=fc763f34&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&id=fc763f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc763f34",
  null
  
)

export default component.exports